import SplitType from 'split-type';

function textAnimations(parent = document) {
    
    // Automatic text split
    if (parent.querySelectorAll('[data-split]')) {
        setTimeout(() => {
            parent.querySelectorAll('[data-split]').forEach((splitElt) => {
                let splitType = (splitElt.getAttribute('data-split')) ? splitElt.getAttribute('data-split') : 'lines,words';
                let selector = (splitElt.querySelectorAll('p').length > 0) ? splitElt.querySelectorAll('p') : splitElt;
                let split = new SplitType(selector, { types: splitType });
                
                if (splitElt.hasAttribute('data-split-animation')){
                    if (split.lines) {
                        split.lines.forEach((l, index) => {
                            l.style.setProperty('--l-index', index);
                        });
                    }
                    if (split.words) {
                        split.words.forEach((w, index) => {
                            w.style.setProperty('--w-index', index);
                        });
                    }
                    if (split.chars) {
                        split.chars.forEach((c, index) => {
                            c.style.setProperty('--c-index', index);
                        });
                    }
                }
            });
        }, 0);
    }

}

export { textAnimations };
